<template>
    <div class="newPage">
        <div class="content">
            <breadcrumb></breadcrumb>
            <div class="list">
                <div class="item">
                    <div class="header">
                        <div class="title">
                            经纬度逆向
                        </div>
                        <div class="center"></div>
                    </div>
                    <div class="itemContent">
                        <div class="formItem">
                            <div class="label">上传</div>
                            <div class="value">
<!--                                <el-upload-->
<!--                                        :action="uploadEcxl"-->
<!--                                        :on-success="handlesuccess"-->
<!--                                        :on-remove="handleremove"-->
<!--                                        :limit="1"-->
<!--                                        :headers="headers"-->
<!--                                        :file-list="fileList">-->
<!--                                    &lt;!&ndash;                                    <el-button size="small" type="primary">点击上传</el-button>&ndash;&gt;-->
<!--                                    <a-button size="small" type="primary" class="btn" >点击上传</a-button>-->
<!--                                </el-upload>-->

                                <el-upload
                                        ref="checkUploadRef"
                                        :limit="1"
                                        accept=".xlsx, .xls"
                                        :headers="headers"
                                        :action="uploadEcxl"
                                        :on-exceed="handleExceed"
                                        :on-success="handlesuccess"
                                        :http-request="uploadSectionFile"
                                >
                                    <a-button size="small" type="primary" class="btn" >点击上传</a-button>
                                </el-upload>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import url from "../../../utils/UrlApi"
    import Breadcrumb from "../../../components/breadcrumb";

    import axios from 'axios';
    import { saveAs } from 'file-saver';
    const request = axios.create({
        // 超时
        timeout: 10000
    })

    export default {
        name: "reverseLonLat",
        components: {Breadcrumb},
        data() {
            return {

                fileList: [],

                uploadEcxl: url.uploadEcxlLonLat,
                headers: {
                    Authorization: localStorage.getItem('token')
                },

                paramsData: {
                    tabList: [],
                    type: 0,
                    station: ''
                },
            }
        },
        computed: {
            userType: {
                get() {
                    return this.$store.state.userType;
                },
                set(val) {
                    this.$store.commit("updateUserType", val);
                }
            },
        },
        methods: {
            uploadSectionFile(params){
                const loading = this.$loading({
                    lock: true,
                    text: '导入中',
                    spinner: 'el-icon-loading',
                });
                const data = new FormData();
                data.append(params.filename, params.file);
                request.post(params.action, data, {
                    headers: { 'Content-Type': 'multipart/form-data', Authorization: localStorage.getItem('token') },
                    responseType: 'blob'
                })
                    .then(resp => {
                        loading.close();
                        // console.log(params);
                        // console.log(resp);


                        this.$message.success('上传成功')
                        let fileName= decodeURI(resp.headers.name)
                        // console.log(fileName)
                        saveAs(resp.data, fileName);

                    }).catch(err => {
                    loading.close();
                    console.log(err);
                });

            },
            handleExceed(){
                this.$message.error('超出文件限制个数: 1 个')
            },
            handlesuccess(response, file, fileList) {
                if (response.code === '200') {
                    this.flieData = response.data
                } else {
                    this.$message.error('上传失败')
                    this.fileList = []
                }
            },

            handleremove(file, fileList) {
                this.flieData = null
                this.paramsData.tabList = []
            },

            exceldownload(type) {
                window.open(url.exceldownload+'?type='+type, '_blank')
            },
        }
    }
</script>

<style scoped lang="less">
    .newPage {
        .content {
            .list {
                .item {
                    margin: 20px;
                    background-color: #fff;
                    border-radius: 20px;
                    padding: 20px;
                    .header {
                        display: flex;
                        align-items: center;
                        .title {
                        }
                        .center {
                            flex: 1;

                        }
                        .btn {
                            /*background-color: #1daaf1;*/
                            /*color: #fff;*/
                            margin: 0 4px;
                        }
                    }
                    .itemContent {
                        .formItem {
                            display: flex;
                            align-items: center;
                            margin: 10px 0;
                            .label {
                                color: #000;
                                width: 180px;
                            }
                            .value {
                                input[type='text'] {
                                    border: 1px solid #ddd;
                                    padding: 4px 10px;
                                    border-radius: 4px;
                                }
                            }
                            .tabBox {
                                display: flex;
                                .tab {
                                    padding: 8px;
                                    border: 1px solid #ddd;
                                    margin: 0 4px;
                                    border-radius: 6px;
                                    cursor: pointer;
                                }
                                .active {
                                    background-color: #1daaf1;
                                    color: #fff;
                                }
                            }
                            .btn {
                                background-color: #1daaf1;
                                margin-right: 20px;
                                color: #fff;
                            }
                        }
                        .text {
                            color: #409EFF;
                        }
                    }
                }
            }
        }
    }
</style>